/**
 * @jest-environment jsdom
 */

const isIE = /Trident|MSIE/.test(navigator.userAgent);

const toDollar = number => {
  let dollar = `$${Math.abs(parseFloat(number))
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
  if (`${number}`.indexOf('.') === -1) {
    dollar = dollar.replace(/\.\d+/, '');
  }
  if (number < 0) {
    dollar = `-${dollar}`;
  }
  return dollar;
};

const toRoundedDollar = number => toDollar(Math.round(number));

export { isIE, toDollar, toRoundedDollar };
